import React from 'react';
import { motion } from 'framer-motion';
import useCustomNavigate from '../../hooks/useCustomNavigate';

const services = [
    { name: 'Interior Designer', description: 'Transform your home with expert design tailored to your style and space.' },
    { name: 'Vastu Facilities', description: 'Align your living space with positive energy using traditional Vastu principles.' },
    { name: 'Home Services', description: 'Get quick and reliable solutions for cleaning, repairs, and daily maintenance.' },
    { name: 'Movers & Packers', description: 'Make shifting hassle-free with professional packing and moving support.' },
    { name: 'Legal Team', description: 'Ensure your property transactions are secure with trusted legal experts.' },
    { name: 'Modular Kitchens', description: 'Upgrade your cooking space with modern, customizable kitchen setups.' },
    { name: 'Construction Companies', description: 'Hire top-rated builders for residential or commercial projects.' },
    { name: 'Furniture', description: 'Furnish your home with stylish and comfortable pieces that match your vibe.' }
];

const fadeUpVariant = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.1,
            duration: 0.6,
            ease: [0.25, 0.1, 0.25, 1] // Custom cubic-bezier for smooth finish
        }
    })
};


const AllServices = () => {
    const { goTo } = useCustomNavigate();

    return (
        <div className="min-h-screen bg-gray-50 p-6 py-[140px]">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">Property Services</h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {services.map((service, index) => (
                        <motion.div
                            key={index}
                            className="bg-white p-6 rounded-lg shadow hover:shadow-md transition border border-gray-200 hover:border-green-500"
                            variants={fadeUpVariant}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.2 }}
                            custom={index}
                        >
                            <h3 className="text-xl font-semibold text-gray-800 mb-2">{service.name}</h3>
                            <p className="text-sm text-gray-600 mb-4">{service.description}</p>

                            <button
                                onClick={() => goTo(`/service/list/${service.name.replace(/ /g, '-')}`)}
                                className="mt-auto text-sm bg-green-600 text-white py-2 px-4 rounded transition duration-300 relative group overflow-hidden"
                            >
                                <span className="inline-block transition-transform group-hover:translate-x-1">
                                    Explore →
                                </span>
                            </button>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AllServices;
